import { useState } from 'react';
import { useNotify } from 'react-admin';
import { AdminCreateSessionBalancesRequestDto } from 'shared/api';
import { API_BASE_URL_ADMIN } from 'shared/config';
import { API_URL } from 'shared/constants/api-url';
import { httpClient } from 'shared/services/http-client';
import { handleValidationError } from 'shared/utils/handle-validation-error';
import { ERROR_MSG } from "../../shared/constants/error-msg";
import { isForbiddenError, isValidationError } from "../../shared/utils/errors";

interface Arguments {
  companyId: string;
}

export const useAddSessionBalance = ({ companyId }: Arguments) => {
  const [isLoading, setIsLoading] = useState(false);
  const notify = useNotify();

  const url = API_URL.addSessionBalances;

  const addSessionBalances = async (data: AdminCreateSessionBalancesRequestDto) => {
    setIsLoading(true);

    await httpClient(`${API_BASE_URL_ADMIN}${url}`, {
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(() => {
        notify('Баланс консультаций добавлен', { type: 'success' });
      })
      .catch((error) => {
        let msg = error.message || ERROR_MSG.internal

        if (isForbiddenError(error)) {
          msg = ERROR_MSG.forbidden
        }

        if (isValidationError(error)) {
          const message = handleValidationError(error.body.data);
  
          msg = message || msg;
        }

        notify(msg, { type: 'error' });

        throw error;
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return { addSessionBalances, isLoading };
};
